// src/components/EmailVerificationBanner.js
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const EmailVerificationBanner = () => {
const { currentUser, resendVerificationEmail } = useAuth();
const [sending, setSending] = useState(false);
const [message, setMessage] = useState('');
const [dismissed, setDismissed] = useState(false);

// Don't show if email is verified or banner is dismissed
if (!currentUser || currentUser.isEmailVerified || dismissed) {
    return null;
}

const handleResend = async () => {
    setSending(true);
    setMessage('');

    try {
    await resendVerificationEmail();
    setMessage('Verification email sent! Check your inbox');
    } catch (error) {
    setMessage(error.response?.data?.error || 'Error sending email.');
    } finally {
    setSending(false);
    }
};

return (
    <div style={{
    backgroundColor: '#fef3c7',
    borderBottom: '2px solid #f59e0b',
    padding: '12px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '10px'
    }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span style={{ fontSize: '20px' }}>⚠️</span>
        <div>
        <strong style={{ color: '#92400e' }}>Email not verified</strong>
        <p style={{ margin: '2px 0 0 0', fontSize: '14px', color: '#78350f' }}>
            Please verify your email to access all features.
        </p>
        </div>
    </div>

    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        {message && (
        <span style={{
            fontSize: '12px',
            color: message.includes('Erreur') ? '#dc2626' : '#059669'
        }}>
            {message}
        </span>
        )}
        <button
        onClick={handleResend}
        disabled={sending}
        style={{
            padding: '8px 16px',
            backgroundColor: '#f59e0b',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: sending ? 'not-allowed' : 'pointer',
            opacity: sending ? 0.6 : 1
        }}
        >
        {sending ? 'Sending...' : 'Resend Verification Email'}
        </button>
        <button
        onClick={() => setDismissed(true)}
        style={{
            padding: '8px',
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: '18px',
            color: '#92400e'
        }}
        >
        ×
        </button>
    </div>
    </div>
);
};

export default EmailVerificationBanner;
